// Newsletter honeypot: fill the hidden :name field with the reversed email.
// Server checks params[:name] == params[:email].reverse to reject bots.

function initNewsletterForms() {
  document.querySelectorAll(".newsletter-form").forEach(function(form) {
    const emailField    = form.querySelector('input[type="email"]');
    // Unique, non-obvious id so JS finds exactly this field without
    // colliding with other "name" inputs elsewhere on the page.
    const honeypotField = form.querySelector('#nf_contact');

    if (!emailField || !honeypotField) return;

    const fillHoneypot = function() {
      honeypotField.value = emailField.value.split("").reverse().join("");
    };

    emailField.addEventListener("input", fillHoneypot);
    form.addEventListener("submit", fillHoneypot);
  });
}

document.addEventListener("DOMContentLoaded", initNewsletterForms);
